import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { isPresent } from 'services/operators';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { getTransportIncidentItemIdentifier, ITransportIncidentItem } from '../models/transport-incident-item.model';

export type EntityResponseType = HttpResponse<ITransportIncidentItem>;
export type EntityArrayResponseType = HttpResponse<ITransportIncidentItem[]>;

@Injectable({ providedIn: 'root' })
export class TransportIncidentItemService {
  protected resourceUrl: string;

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('api/transport-incident-items');
  }

  create(transportIncidentItem: ITransportIncidentItem): Observable<EntityResponseType> {
    return this.http.post<ITransportIncidentItem>(this.resourceUrl, transportIncidentItem, { observe: 'response' });
  }

  update(transportIncidentItem: ITransportIncidentItem): Observable<EntityResponseType> {
    return this.http.put<ITransportIncidentItem>(`${this.resourceUrl}/${getTransportIncidentItemIdentifier(transportIncidentItem)}`, transportIncidentItem, {
      observe: 'response',
    });
  }

  partialUpdate(transportIncidentItem: ITransportIncidentItem): Observable<EntityResponseType> {
    return this.http.patch<ITransportIncidentItem>(`${this.resourceUrl}/${getTransportIncidentItemIdentifier(transportIncidentItem)}`, transportIncidentItem, {
      observe: 'response',
    });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ITransportIncidentItem>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransportIncidentItem[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  addTransportIncidentItemToCollectionIfMissing(
    transportIncidentItemCollection: ITransportIncidentItem[],
    ...transportIncidentItemsToCheck: (ITransportIncidentItem | null | undefined)[]
  ): ITransportIncidentItem[] {
    const transportIncidentItems: ITransportIncidentItem[] = transportIncidentItemsToCheck.filter(isPresent);
    if (transportIncidentItems.length > 0) {
      const transportIncidentItemCollectionIdentifiers = transportIncidentItemCollection.map(transportIncidentItemItem =>
        getTransportIncidentItemIdentifier(transportIncidentItemItem)
      );
      const transportIncidentItemsToAdd = transportIncidentItems.filter(transportIncidentItemItem => {
        const transportIncidentItemIdentifier = getTransportIncidentItemIdentifier(transportIncidentItemItem);
        if (transportIncidentItemIdentifier == null || transportIncidentItemCollectionIdentifiers.includes(transportIncidentItemIdentifier)) {
          return false;
        }
        transportIncidentItemCollectionIdentifiers.push(transportIncidentItemIdentifier);
        return true;
      });
      return [...transportIncidentItemsToAdd, ...transportIncidentItemCollection];
    }
    return transportIncidentItemCollection;
  }
}
